import React,{Component} from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from 'classnames';
import { renderPass, renderField, renderCheckbox, required, minValue, renderTextArea, number, positive_float } from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getZones, updateZone } from "../../../actions/actionZones";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import {getLicenses} from "../../../actions/actionSystemInfo";

const minValue50 = minValue(50);

class ZoneFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentZone: null,
            auto_scaling: false,
            activeTab: 0
        };
        this.submitZone= this.submitZone.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.initializeForm = this.initializeForm.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    toggle(tab){
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    handleUpdateSuccess(){
        const {errorUpdateMessage} = this.props;
        if(errorUpdateMessage){
            NotificationManager.error(errorUpdateMessage,"Update Zone", 3000);
        }
        else {
            NotificationManager.success("Zone Update", "Zone Updated Successfully");
            this.props.history.push("/zones");
        }
    }

    handleUpdateError(){
        const {updateZoneError} = this.props;
        if(updateZoneError){
            NotificationManager.error(updateZoneError,"Update Zone", 3000);
        }
    }

    handleCreateSuccess(){
        const {errorCreateMessage} = this.props; 
        if(errorCreateMessage){
            NotificationManager.error(errorCreateMessage,"Create Zone", 3000);
        }
        else{
            NotificationManager.success("Zone Created", "Successfully Created Zone");
            this.props.history.push("/zones");
        }
    }

    handleCreateError(){
        const {createZoneError} = this.props;
        if(createZoneError){
            NotificationManager.warning(createZoneError,"Update Zone", 3000);
        } else {
            NotificationManager.warning("something went wrong!", "Update Zone");
        }
    }

    submitZone(userData){
        if (!userData.auto_scaling_enabled)
            userData.auto_scaling_enabled = false;
        if (!userData.register_dns)
            userData.register_dns = false;
        if (userData.auto_scaling_enabled && !userData.aws_enabled)
            userData.aws_enabled = false;
        if (userData.auto_scaling_enabled && !userData.digital_ocean_enabled)
            userData.digital_ocean_enabled = false;
        if (this.props.fromUpdate){
            userData.zone_id = this.props.zoneId;
            this.props.updateZone(userData).
                then(() => this.handleUpdateSuccess()).
                catch(() => this.handleUpdateError());
        }
        else {
            this.props.createZone(userData).
                then(() => this.handleCreateSuccess()).
                catch(() => this.handleCreateError());
        }
    }


    cancelButton(){
        this.props.history.push("/zones");
    }

    initializeForm(res){
        let currentZone = res.response.zones.find(zone => zone.zone_id === this.props.zoneId);
        this.setState({currentZone: currentZone});
        this.props.initialize({
            auto_scaling_enabled: currentZone.auto_scaling_enabled,
            register_dns: currentZone.register_dns,
            dns_registration_provider: currentZone.dns_registration_provider,
            base_domain_name: currentZone.base_domain_name,
            allow_origin_domain: currentZone.allow_origin_domain,
            upstream_auth_address: currentZone.upstream_auth_address,
            proxy_connections: currentZone.proxy_connections,
            proxy_hostname: currentZone.proxy_hostname,
            proxy_path: currentZone.proxy_path,
            proxy_port: currentZone.proxy_port,
            nginx_cert: currentZone.nginx_cert,
            nginx_key: currentZone.nginx_key,
            zone_name: currentZone.zone_name,
            load_strategy: currentZone.load_strategy,
            prioritize_static_agents: currentZone.prioritize_static_agents,
            search_alternate_zones: currentZone.search_alternate_zones,
            standby_cores: currentZone.standby_cores,
            standby_gpus: currentZone.standby_gpus,
            standby_memory_mb: currentZone.standby_memory_mb,
            downscale_backoff: currentZone.downscale_backoff,
            zone_id: currentZone.zone_id,
            aws_enabled: currentZone.aws_enabled,
            aws_region: currentZone.aws_region,
            aws_access_key_id: currentZone.aws_access_key_id,
            aws_secret_access_key: currentZone.aws_secret_access_key,
            ec2_agent_ami_id: currentZone.ec2_agent_ami_id,
            agent_cores_override: currentZone.agent_cores_override,
            agent_gpus_override: currentZone.agent_gpus_override,
            agent_memory_override_gb: currentZone.agent_memory_override_gb,
            ec2_agent_instance_type: currentZone.ec2_agent_instance_type,
            ec2_agent_key_pair_name: currentZone.ec2_agent_key_pair_name,
            aws_max_ec2_nodes: currentZone.aws_max_ec2_nodes,
            ec2_agent_security_group_ids:  JSON.stringify(currentZone.ec2_agent_security_group_ids),
            ec2_agent_subnet_id: currentZone.ec2_agent_subnet_id,
            ec2_agent_startup_script: currentZone.ec2_agent_startup_script,
            ec2_agent_iam: currentZone.ec2_agent_iam,
            ec2_agent_ebs_volume_type: currentZone.ec2_agent_ebs_volume_type,
            ec2_agent_ebs_volume_size_gb: currentZone.ec2_agent_ebs_volume_size_gb,
            ec2_custom_tags: JSON.stringify(currentZone.ec2_custom_tags),
            digital_ocean_enabled: currentZone.digital_ocean_enabled,
            digital_ocean_max_droplets: currentZone.digital_ocean_max_droplets,
            digital_ocean_token: currentZone.digital_ocean_token,
            digital_ocean_region: currentZone.digital_ocean_region,
            digital_ocean_droplet_image: currentZone.digital_ocean_droplet_image,
            digital_ocean_droplet_size: currentZone.digital_ocean_droplet_size,
            digital_ocean_tags: currentZone.digital_ocean_tags,
            digital_ocean_sshkey_name: currentZone.digital_ocean_sshkey_name,
            digital_ocean_firewall_name: currentZone.digital_ocean_firewall_name,
            digital_ocean_startup_script: currentZone.digital_ocean_startup_script,
            oci_enabled: currentZone.oci_enabled,
            oci_user_ocid: currentZone.oci_user_ocid,
            oci_fingerprint: currentZone.oci_fingerprint,
            oci_private_key: currentZone.oci_private_key,
            oci_max_instances: currentZone.oci_max_instances,
            oci_tenancy_ocid: currentZone.oci_tenancy_ocid,
            oci_region: currentZone.oci_region,
            oci_compartment_ocid: currentZone.oci_compartment_ocid,
            oci_availability_domain: currentZone.oci_availability_domain,
            oci_shape: currentZone.oci_shape,
            oci_flex_cpus: currentZone.oci_flex_cpus,
            oci_flex_memory_gb: currentZone.oci_flex_memory_gb,
            oci_boot_volume_gb: currentZone.oci_boot_volume_gb,
            oci_custom_tags: JSON.stringify(currentZone.oci_custom_tags),
            oci_image_ocid: currentZone.oci_image_ocid,
            oci_subnet_ocid: currentZone.oci_subnet_ocid,
            oci_ssh_public_key: currentZone.oci_ssh_public_key,
            oci_startup_script: currentZone.oci_startup_script,
            gcp_enabled: currentZone.gcp_enabled,
            gcp_max_instances: currentZone.gcp_max_instances,
            gcp_project: currentZone.gcp_project,
            gcp_region: currentZone.gcp_region,
            gcp_zone: currentZone.gcp_zone,
            gcp_machine_type: currentZone.gcp_machine_type,
            gcp_image: currentZone.gcp_image,
            gcp_startup_script: currentZone.gcp_startup_script,
            gcp_boot_volume_gb: currentZone.gcp_boot_volume_gb,
            gcp_disk_type: currentZone.gcp_disk_type,
            gcp_cmek: currentZone.gcp_cmek,
            gcp_network: currentZone.gcp_network,
            gcp_subnetwork: currentZone.gcp_subnetwork,
            gcp_public_ip: currentZone.gcp_public_ip,
            gcp_network_tags: JSON.stringify(currentZone.gcp_network_tags),
            gcp_custom_labels: JSON.stringify(currentZone.gcp_custom_labels),
            gcp_credentials: currentZone.gcp_credentials,
            gcp_metadata: JSON.stringify(currentZone.gcp_metadata),
            gcp_service_account: JSON.stringify(currentZone.gcp_service_account),
            gcp_guest_accelerators: JSON.stringify(currentZone.gcp_guest_accelerators),
            gcp_config_override: JSON.stringify(currentZone.gcp_config_override),
            azure_enabled: currentZone.azure_enabled,
            azure_max_instances: currentZone.azure_max_instances,
            azure_subscription_id: currentZone.azure_subscription_id,
            azure_resource_group: currentZone.azure_resource_group,
            azure_tenant_id: currentZone.azure_tenant_id,
            azure_client_id: currentZone.azure_client_id,
            azure_client_secret: currentZone.azure_client_secret,
            azure_region: currentZone.azure_region,
            azure_vm_size: currentZone.azure_vm_size,
            azure_os_disk_type: currentZone.azure_os_disk_type,
            azure_image_reference: JSON.stringify(currentZone.azure_image_reference),
            azure_network_sg: currentZone.azure_network_sg,
            azure_subnet: currentZone.azure_subnet,
            azure_os_disk_size_gb: currentZone.azure_os_disk_size_gb,
            azure_tags: JSON.stringify(currentZone.azure_tags),
            azure_os_username: currentZone.azure_os_username,
            azure_os_password: currentZone.azure_os_password,
            azure_ssh_public_key: currentZone.azure_ssh_public_key,
            azure_startup_script: currentZone.azure_startup_script,
            azure_config_override: JSON.stringify(currentZone.azure_config_override),
            azure_public_ip: currentZone.azure_public_ip,
        });
    }


    componentDidMount(){
        if (this.props.fromUpdate){
            this.props.getZones().then((res) => this.initializeForm(res));
        }
        this.props.getLicenses()
            .then(() => {
                const {licenses} = this.props;
                for (let i in licenses) {
                    if (licenses[i].is_verified == true && licenses[i].features && licenses[i].features.auto_scaling === true) {
                        this.setState({auto_scaling: true})
                    }
                }
            });

    }

    render(){
        const {handleSubmit, has_aws_enabled, has_do_enabled, has_oci_enabled, has_gcp_enabled, has_azure_enabled,
            has_scaling_enabled, has_proxy, has_dns, has_dns_registration_provider} = this.props;
        const {currentZone} =  this.state;
        const aws_enabled_checked = currentZone && currentZone.aws_enabled;
        const digital_ocean_enabled_checked = currentZone && currentZone.digital_ocean_enabled;
        const oci_enabled_checked = currentZone && currentZone.oci_enabled;
        const gcp_enabled_checked = currentZone && currentZone.gcp_enabled;
        const azure_enabled_checked = currentZone && currentZone.azure_enabled;
        const gcp_public_ip_checked = currentZone && currentZone.gcp_public_ip;
        const azure_public_ip_checked = currentZone && currentZone.azure_public_ip;
        const scaling_enabled_checked = currentZone && currentZone.auto_scaling_enabled;
        const register_dns_enabled_checked = currentZone && currentZone.dns_registration_provider;
        const proxy_checked = currentZone && currentZone.proxy_connections;
        const prioritize_static_agents_checked = currentZone && currentZone.prioritize_static_agents;
        const search_alternate_zones_checked = currentZone && currentZone.search_alternate_zones;
        const do_required = has_do_enabled || has_dns_registration_provider === 'digital_ocean';
        const aws_required = has_aws_enabled || has_dns_registration_provider === 'aws';
        const oci_required = has_oci_enabled || has_dns_registration_provider === 'oci';
        const gcp_required = has_gcp_enabled || has_dns_registration_provider === 'gcp';
        const azure_required = has_azure_enabled || has_dns_registration_provider === 'azure';


        return (
            <Form onSubmit={handleSubmit(this.submitZone)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="4">
                                <Label htmlFor="zone_name" className="requiredasterisk">Zone Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="zone_name"
                                    id="zone_name"
                                    component={renderField} 
                                    validate={required}
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                     <FormGroup>
                        <Row>
                            <Col sm="4">
                                <Label htmlFor="allow_origin_domain" className="requiredasterisk">Allow Origin Domain</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="allow_origin_domain"
                                       id="allow_origin_domain"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="4">
                                <Label htmlFor="upstream_auth_address" className="requiredasterisk">Upstream Auth Address</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="upstream_auth_address"
                                       id="upstream_auth_address"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="4">
                                <Label htmlFor="load_strategy" className="requiredasterisk">Load Balance Strategy</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="load_strategy"
                                       id="load_strategy"
                                       component="select"
                                       clearable={false}>
                                    <option value="least_load">Least Load</option>
                                    <option value="most_load">Most Load</option>
                                    <option value="least_kasms">Least Sessions</option>
                                    <option value="most_kasms">Most Sessions</option>
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="4">
                                <Label htmlFor="search_alternate_zones">Search Alternate Zones</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="search_alternate_zones"
                                       id="search_alternate_zones"
                                       checked = {search_alternate_zones_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="4">
                                <Label htmlFor="proxy_connections">Proxy Connections</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="proxy_connections"
                                       id="proxy_connections"
                                       checked = {proxy_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    { has_proxy &&
                        <React.Fragment>
                            <FormGroup>
                                <Row>
                                    <Col sm="4">
                                        <Label htmlFor="proxy_hostname" className="requiredasterisk">Proxy Hostname</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                               name="proxy_hostname"
                                               id="proxy_hostname"
                                               component={renderField}
                                               validate={required}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm="4">
                                        <Label htmlFor="proxy_path" className="requiredasterisk">Proxy Path</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                               name="proxy_path"
                                               id="proxy_path"
                                               component={renderField}
                                               validate={required}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm="4">
                                        <Label htmlFor="proxy_port" className="requiredasterisk">Proxy Port</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            type="number"
                                            name="proxy_port"
                                            id="proxy_port"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </React.Fragment>
                    }
                    {this.state.auto_scaling &&
                        <React.Fragment>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="auto_scaling_enabled">Scaling Enabled</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                        name="auto_scaling_enabled"
                                        id="auto_scaling_enabled"
                                        checked = {scaling_enabled_checked}
                                        component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>

                        { has_scaling_enabled &&
                            <React.Fragment>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="prioritize_static_agents">Prioritize Static Agents</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="checkbox"
                                                   name="prioritize_static_agents"
                                                   id="prioritize_static_agents"
                                                   checked = {prioritize_static_agents_checked}
                                                   component={renderCheckbox}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="standby_cores" className="requiredasterisk">Standby Cores</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field
                                                type="number"
                                                name="standby_cores"
                                                id="standby_cores"
                                                component={renderField}
                                                validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="standby_gpus" className="requiredasterisk">Standby GPUs</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field
                                                type="number"
                                                name="standby_gpus"
                                                id="standby_gpus"
                                                component={renderField}
                                                validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="standby_memory_mb" className="requiredasterisk">Standby Memory (MB)</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field
                                                type="number"
                                                name="standby_memory_mb"
                                                id="standby_memory_mb"
                                                component={renderField}
                                                validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="standby_cores" className="requiredasterisk">Downscale Backoff (Seconds)</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field
                                                type="number"
                                                name="downscale_backoff"
                                                id="downscale_backoff"
                                                component={renderField}
                                                validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="agent_cores_override" className="requiredasterisk">Agent Cores Override</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="number"
                                                    name="agent_cores_override"
                                                    id="agent_cores_override"
                                                    component={renderField}
                                                    validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="agent_gpus_override" className="requiredasterisk">Agent GPUs Override</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="number"
                                                    name="agent_gpus_override"
                                                    id="agent_gpus_override"
                                                    component={renderField}
                                                    validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="5">
                                            <Label htmlFor="agent_memory_override_gb" className="requiredasterisk">Agent Memory Override (GB)</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="number"
                                                    name="agent_memory_override_gb"
                                                    id="agent_memory_override_gb"
                                                    component={renderField}
                                                    validate={positive_float}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="register_dns">Register DNS</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="checkbox"
                                                   name="register_dns"
                                                   id="register_dns"
                                                   checked = {register_dns_enabled_checked}
                                                   component={renderCheckbox}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                { has_dns &&
                                <React.Fragment>
                                    <FormGroup>
                                        <Row>
                                            <Col sm="4">
                                                <Label htmlFor="dns_registration_provider" className="requiredasterisk">DNS
                                                    Registration Provider</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field type="text"
                                                       name="dns_registration_provider"
                                                       id="dns_registration_provider"
                                                       component="select"
                                                       validate={required}
                                                       clearable={false}>
                                                    <option value=""></option>
                                                    <option value="aws">AWS</option>
                                                    <option value="azure">Azure</option>
                                                    <option value="digital_ocean">Digital Ocean</option>
                                                    <option value="oci">Oracle Cloud</option>
                                                    <option value="gcp">Google Cloud</option>
                                                </Field>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col sm="4">
                                                <Label htmlFor="base_domain_name" className="requiredasterisk">Base
                                                    Domain Name</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field type="text"
                                                       name="base_domain_name"
                                                       id="base_domain_name"
                                                       component={renderField}
                                                       validate={required}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </React.Fragment>
                                }

                                 <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="nginx_cert" className="requiredasterisk">Nginx Cert</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="text"
                                                   name="nginx_cert"
                                                   id="nginx_cert"
                                                   component={renderTextArea}
                                                   validate={required}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm="4">
                                            <Label htmlFor="nginx_key" className="requiredasterisk">Nginx Key</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="text"
                                                   name="nginx_key"
                                                   id="nginx_key"
                                                   component={renderTextArea}
                                                   validate={required}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>


                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 0 })}
                                            onClick={() => {
                                                this.toggle(0);
                                            }}
                                        >
                                            AWS
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 1 })}
                                            onClick={() => {
                                                this.toggle(1);
                                            }}
                                        >
                                            Digital Ocean
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 2 })}
                                            onClick={() => {
                                                this.toggle(2);
                                            }}
                                        >
                                            Oracle Cloud
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 3 })}
                                            onClick={() => {
                                                this.toggle(3);
                                            }}
                                        >
                                            Google Cloud
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === 4 })}
                                            onClick={() => {
                                                this.toggle(4);
                                            }}
                                        >
                                            Azure
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId={0}>
                                        <React.Fragment>
                                             <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="aws_access_key_id" className={aws_required ? "requiredasterisk" : ""}>AWS Access Key Id</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="text"
                                                               name="aws_access_key_id"
                                                               id="aws_access_key_id"
                                                               component={renderField}
                                                               validate={aws_required ? required : null}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="aws_secret_access_key"  className={aws_required ? "requiredasterisk" : ""}>AWS Secret Access Key</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="password"
                                                            name="aws_secret_access_key"
                                                            id="aws_secret_access_key"
                                                            component={renderPass}
                                                            validate={aws_required ? required : null}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="aws_enabled" className="requiredasterisk">AWS Scaling Enabled</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="checkbox"
                                                               name="aws_enabled"
                                                               id="aws_enabled"
                                                               checked = {aws_enabled_checked}
                                                               component={renderCheckbox}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            { has_aws_enabled &&
                                                <React.Fragment>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="aws_region" className="requiredasterisk">AWS Region</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="aws_region"
                                                                       id="aws_region"
                                                                       component={renderField}
                                                                       validate={required}
                                                                       placeholder="us-east-1"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_agent_ami_id" className="requiredasterisk">AWS: EC2 Agent AMI Id</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="ec2_agent_ami_id"
                                                                       id="ec2_agent_ami_id"
                                                                       component={renderField}
                                                                       validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="5">
                                                                <Label htmlFor="ec2_agent_instance_type" className="requiredasterisk">AWS: EC2 Agent Instance Type</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field
                                                                    name="ec2_agent_instance_type"
                                                                    id="ec2_agent_instance_type"
                                                                    component={renderField}
                                                                    validate={required}
                                                                    autoComplete='random-string'
                                                                    placeholder="t3.micro"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_agent_key_pair_name" className="requiredasterisk">AWS: EC2 Agent Key Pair Name</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="ec2_agent_key_pair_name"
                                                                       id="ec2_agent_key_pair_name"
                                                                       validate={required}
                                                                       component={renderField}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="aws_max_ec2_nodes" className="requiredasterisk">AWS Max EC2 Nodes</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field name="aws_max_ec2_nodes"
                                                                       id="aws_max_ec2_nodes"
                                                                       component={renderField}
                                                                       validate={number}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_agent_security_group_ids" className="requiredasterisk">AWS: EC2 Security Group IDs (JSON)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                    name="ec2_agent_security_group_ids"
                                                                    id="ec2_agent_security_group_ids"
                                                                    component={renderTextArea}
                                                                    validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_agent_subnet_id" className="requiredasterisk">AWS: EC2 Agent Subnet ID</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="ec2_agent_subnet_id"
                                                                       id="ec2_agent_subnet_id"
                                                                       component={renderField}
                                                                       validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="5">
                                                                <Label htmlFor="ec2_agent_ebs_volume_size_gb" className="requiredasterisk">AWS: EC2 Agent EBS Volume Size (GB)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="number"
                                                                       name="ec2_agent_ebs_volume_size_gb"
                                                                       id="ec2_agent_ebs_volume_size_gb"
                                                                       component={renderField}
                                                                       validate={number}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="5">
                                                                <Label htmlFor="ec2_agent_ebs_volume_type" className="requiredasterisk">AWS: EC2 Agent EBS Volume Type</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="ec2_agent_ebs_volume_type"
                                                                       id="ec2_agent_ebs_volume_type"
                                                                       component={renderField}
                                                                       validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_agent_iam" className="requiredasterisk">AWS: EC2 Agent IAM</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="ec2_agent_iam"
                                                                       id="ec2_agent_iam"
                                                                       component={renderField}
                                                                       validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_custom_tags">AWS: EC2 Custom Tags (JSON)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="ec2_custom_tags"
                                                                       id="ec2_custom_tags"
                                                                       component={renderTextArea}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="ec2_agent_startup_script" className="requiredasterisk whitespacePre">AWS: EC2 Agent Startup Script</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                       name="ec2_agent_startup_script"
                                                                       id="ec2_agent_startup_script"
                                                                       component={renderTextArea}
                                                                       validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                    </TabPane>
                                    <TabPane tabId={1}>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="digital_ocean_token" className={do_required ? "requiredasterisk" : ""}>Token</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="password"
                                                           name="digital_ocean_token"
                                                           id="digital_ocean_token"
                                                           component={renderPass}
                                                           validate={do_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="digital_ocean_enabled" className="requiredasterisk">Digital Ocean Scaling Enabled</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="checkbox"
                                                           name="digital_ocean_enabled"
                                                           id="digital_ocean_enabled"
                                                           checked = {digital_ocean_enabled_checked}
                                                           component={renderCheckbox}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        {has_do_enabled &&
                                            <React.Fragment>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="5">
                                                            <Label htmlFor="digital_ocean_max_droplets" className="requiredasterisk">Max Droplets</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="number"
                                                                   name="digital_ocean_max_droplets"
                                                                   id="digital_ocean_max_droplets"
                                                                   component={renderField}
                                                                   validate={number}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_region" className="requiredasterisk">Region</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_region"
                                                                   id="digital_ocean_region"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_droplet_image" className="requiredasterisk">Image</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_droplet_image"
                                                                   id="digital_ocean_droplet_image"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_droplet_size" className="requiredasterisk">Droplet Size</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_droplet_size"
                                                                   id="digital_ocean_droplet_size"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_tags" className="requiredasterisk">Tags</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_tags"
                                                                   id="digital_ocean_tags"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_sshkey_name" className="requiredasterisk">SSH Key Name</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_sshkey_name"
                                                                   id="digital_ocean_sshkey_name"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_firewall_name" className="requiredasterisk">Firewall Name</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_firewall_name"
                                                                   id="digital_ocean_firewall_name"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="digital_ocean_startup_script" className="requiredasterisk">Startup Script</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="digital_ocean_startup_script"
                                                                   id="digital_ocean_startup_script"
                                                                   component={renderTextArea}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                            </React.Fragment>
                                        }
                                    </TabPane>
                                    <TabPane tabId={2}>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_user_ocid" className={oci_required ? "requiredasterisk" : ""}>User OCID</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="oci_user_ocid"
                                                           id="oci_user_ocid"
                                                           placeholder="ocid1.user.oc1..xxx"
                                                           component={renderField}
                                                           validate={oci_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_fingerprint" className={oci_required ? "requiredasterisk" : ""}>Public Key Fingerprint</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="oci_fingerprint"
                                                           id="oci_fingerprint"
                                                           placeholder="xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx:xx"
                                                           component={renderField}
                                                           validate={oci_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_private_key" className={oci_required ? "requiredasterisk" : ""}>Private Key</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="oci_private_key"
                                                           id="oci_private_key"
                                                           placeholder="-----BEGIN PRIVATE KEY-----&#10;...&#10;-----END PRIVATE KEY-----"
                                                           component={renderTextArea}
                                                           validate={oci_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_region" className="requiredasterisk">Region</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="oci_region"
                                                           id="oci_region"
                                                           placeholder="us-ashburn-1"
                                                           component={renderField}
                                                           validate={oci_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                         <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_tenancy_ocid" className="requiredasterisk">Tenancy OCID</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="oci_tenancy_ocid"
                                                           id="oci_tenancy_ocid"
                                                           placeholder="ocid1.tenancy.oc1..xxx"
                                                           component={renderField}
                                                           validate={oci_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_compartment_ocid" className="requiredasterisk">Compartment OCID</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="oci_compartment_ocid"
                                                           id="oci_compartment_ocid"
                                                           placeholder="ocid1.compartment.oc1..xxx"
                                                           component={renderField}
                                                           validate={oci_required ? required : null}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="oci_enabled" className="requiredasterisk">OCI Scaling Enabled</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="checkbox"
                                                           name="oci_enabled"
                                                           id="oci_enabled"
                                                           checked = {oci_enabled_checked}
                                                           component={renderCheckbox}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        {has_oci_enabled &&
                                            <React.Fragment>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="5">
                                                            <Label htmlFor="oci_max_instances" className="requiredasterisk">Max Instances</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="number"
                                                                   name="oci_max_instances"
                                                                   id="oci_max_instances"
                                                                   placeholder="10"
                                                                   component={renderField}
                                                                   validate={number}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_availability_domain" className="requiredasterisk">Availability Domain</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_availability_domain"
                                                                   id="oci_availability_domain"
                                                                   placeholder="BEol:US-ASHBURN-AD-1"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_image_ocid" className="requiredasterisk">Image OCID</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_image_ocid"
                                                                   id="oci_image_ocid"
                                                                   placeholder="ocid1.image.oc1.iad.xxx"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_shape" className="requiredasterisk">Shape</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_shape"
                                                                   id="oci_shape"
                                                                   placeholder="VM.Standard.E4.Flex"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_flex_cpus" className="requiredasterisk">Flex CPUs</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_flex_cpus"
                                                                   id="oci_flex_cpus"
                                                                   placeholder="2"
                                                                   component={renderField}
                                                                   validate={number}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_flex_memory_gb" className="requiredasterisk">Flex Memory GB</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_flex_memory_gb"
                                                                   id="oci_flex_memory_gb"
                                                                   placeholder="4"
                                                                   component={renderField}
                                                                   validate={number}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_boot_volume_gb" className="requiredasterisk">Boot Volume GB</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_boot_volume_gb"
                                                                   id="oci_boot_volume_gb"
                                                                   placeholder="50"
                                                                   component={renderField}
                                                                   validate={[number, minValue50]}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_custom_tags" className="requiredasterisk">Custom Tags (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_custom_tags"
                                                                   id="oci_custom_tags"
                                                                   placeholder='{"name":"value"}'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_subnet_ocid" className="requiredasterisk">Subnet OCID</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_subnet_ocid"
                                                                   id="oci_subnet_ocid"
                                                                   placeholder="ocid1.subnet.oc1.iad.xxx"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_ssh_public_key" className="requiredasterisk">SSH Public Key</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_ssh_public_key"
                                                                   id="oci_ssh_public_key"
                                                                   placeholder="ssh-rsa XXXXXXX..."
                                                                   component={renderTextArea}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="oci_startup_script" className="requiredasterisk">Startup Script</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="oci_startup_script"
                                                                   id="oci_startup_script"
                                                                   placeholder="#!/bin/bash&#10;..."
                                                                   component={renderTextArea}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                            </React.Fragment>
                                        }

                                    </TabPane>
                                    <TabPane tabId={3}>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="gcp_credentials" className={gcp_required ? "requiredasterisk" : ""}>GCP Credentials (JSON)</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="text"
                                                           name="gcp_credentials"
                                                           id="gcp_credentials"
                                                           placeholder='{"foo" : "bar"}'
                                                           component={renderTextArea}
                                                           validate={gcp_required ? required : null}
                                                    />
                                                </Col>

                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Row>
                                                <Col sm="4">
                                                    <Label htmlFor="gcp_enabled" className="requiredasterisk">GCP Scaling Enabled</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field type="checkbox"
                                                           name="gcp_enabled"
                                                           id="gcp_enabled"
                                                           checked = {gcp_enabled_checked}
                                                           component={renderCheckbox}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        {has_gcp_enabled &&
                                            <React.Fragment>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="5">
                                                            <Label htmlFor="gcp_max_instances" className="requiredasterisk">Max Instances</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="number"
                                                                   name="gcp_max_instances"
                                                                   id="gcp_max_instances"
                                                                   placeholder="10"
                                                                   component={renderField}
                                                                   validate={number}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_project" className="requiredasterisk">Project ID</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_project"
                                                                   id="gcp_project"
                                                                   placeholder="project-name"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_region" className="requiredasterisk">Region</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_region"
                                                                   id="gcp_region"
                                                                   placeholder="us-east4"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_zone" className="requiredasterisk">Zone</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_zone"
                                                                   id="gcp_zone"
                                                                   placeholder="us-east4-b"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_machine_type" className="requiredasterisk">Machine Type</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_machine_type"
                                                                   id="gcp_machine_type"
                                                                   placeholder="e2-standard-2"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_image" className="requiredasterisk">Machine Image</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_image"
                                                                   id="gcp_image"
                                                                   placeholder="projects/debian-cloud/global/images/debian-10-buster-v20211209"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_boot_volume_gb" className="requiredasterisk">Boot Volume GB</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_boot_volume_gb"
                                                                   id="gcp_boot_volume_gb"
                                                                   placeholder="50"
                                                                   component={renderField}
                                                                   validate={[number, minValue50]}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_disk_type" className="requiredasterisk">Disk Type</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_disk_type"
                                                                   id="gcp_disk_type"
                                                                   placeholder="pd-ssd"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="6">
                                                            <Label htmlFor="gcp_cmek">Customer Managed Encryption Key (CMEK)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_cmek"
                                                                   id="gcp_cmek"
                                                                   placeholder="projects/project-name/locations/global/keyRings/my-keyring/cryptoKeys/my-key"
                                                                   component={renderField}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_network" className="requiredasterisk">Network</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_network"
                                                                   id="gcp_network"
                                                                   placeholder="projects/project-name/global/networks/default"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_subnetwork" className="requiredasterisk">Sub Network</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_subnetwork"
                                                                   id="gcp_subnetwork"
                                                                   placeholder="projects/project-name/regions/us-east4/subnetworks/default"
                                                                   component={renderField}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_public_ip" className="requiredasterisk">Public IP</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="checkbox"
                                                                   name="gcp_public_ip"
                                                                   id="gcp_public_ip"
                                                                   checked = {gcp_public_ip_checked}
                                                                   component={renderCheckbox}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_network_tags">Network Tags (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_network_tags"
                                                                   id="gcp_network_tags"
                                                                   placeholder='["https-server"]'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_custom_labels">Custom Labels (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_custom_labels"
                                                                   id="gcp_custom_labels"
                                                                   placeholder='{"foo" : "bar"}'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_metadata">Metadata (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_metadata"
                                                                   id="gcp_metadata"
                                                                   placeholder='[{}]'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_service_account">Service Account (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_service_account"
                                                                   id="gcp_service_account"
                                                                   placeholder='{}'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_guest_accelerators">Guest Accelerators (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_guest_accelerators"
                                                                   id="gcp_guest_accelerators"
                                                                   placeholder='[]'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_config_override">GCP Config Override (JSON)</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_config_override"
                                                                   id="gcp_config_override"
                                                                   placeholder='{}'
                                                                   component={renderTextArea}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Row>
                                                        <Col sm="4">
                                                            <Label htmlFor="gcp_startup_script" className="requiredasterisk">Startup Script</Label>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Field type="text"
                                                                   name="gcp_startup_script"
                                                                   id="gcp_startup_script"
                                                                   placeholder="#!/bin/bash&#10;..."
                                                                   component={renderTextArea}
                                                                   validate={required}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </FormGroup>
                                            </React.Fragment>
                                        }

                                    </TabPane>
                                    <TabPane tabId={4}>
                                        <React.Fragment>
                                             <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="azure_subscription_id" className={azure_required ? "requiredasterisk" : ""}>Subscription ID</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="text"
                                                               name="azure_subscription_id"
                                                               id="azure_subscription_id"
                                                               component={renderField}
                                                               validate={azure_required ? required : null}
                                                               placeholder="00000000-0000-0000-0000-000000000000"
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="azure_resource_group"  className={azure_required ? "requiredasterisk" : ""}>Resource Group</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="text"
                                                            name="azure_resource_group"
                                                            id="azure_resource_group"
                                                            component={renderField}
                                                            validate={azure_required ? required : null}
                                                            placeholder="development"
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="azure_tenant_id"  className={azure_required ? "requiredasterisk" : ""}>Tenant ID</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="text"
                                                            name="azure_tenant_id"
                                                            id="azure_tenant_id"
                                                            component={renderField}
                                                            validate={azure_required ? required : null}
                                                            placeholder="00000000-0000-0000-0000-000000000000"
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="azure_client_id"  className={azure_required ? "requiredasterisk" : ""}>Client ID</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="text"
                                                            name="azure_client_id"
                                                            id="azure_client_id"
                                                            component={renderField}
                                                            validate={azure_required ? required : null}
                                                            placeholder="00000000-0000-0000-0000-000000000000"
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="azure_client_secret"  className={azure_required ? "requiredasterisk" : ""}>Client Secret</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="password"
                                                            name="azure_client_secret"
                                                            id="azure_client_secret"
                                                            component={renderPass}
                                                            validate={azure_required ? required : null}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            <FormGroup>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label htmlFor="azure_enabled" className="requiredasterisk">Azure Scaling Enabled</Label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Field type="checkbox"
                                                               name="azure_enabled"
                                                               id="azure_enabled"
                                                               checked = {azure_enabled_checked}
                                                               component={renderCheckbox}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                            { has_azure_enabled &&
                                                <React.Fragment>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_region" className="requiredasterisk">Region</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="azure_region"
                                                                       id="azure_region"
                                                                       component={renderField}
                                                                       validate={required}
                                                                       placeholder="eastus"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_max_instances" className="requiredasterisk">Max Instances</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="azure_max_instances"
                                                                       id="azure_max_instances"
                                                                       component={renderField}
                                                                       validate={number}
                                                                       placeholder="10"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_vm_size" className="requiredasterisk">VM Size</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="azure_vm_size"
                                                                       id="azure_vm_size"
                                                                       component={renderField}
                                                                       validate={required}
                                                                       placeholder="Standard_D2s_v3"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="5">
                                                                <Label htmlFor="azure_os_disk_type" className="requiredasterisk">OS Disk Type</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field
                                                                    name="azure_os_disk_type"
                                                                    id="azure_os_disk_type"
                                                                    component={renderField}
                                                                    validate={required}
                                                                    placeholder="Premium_LRS"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_os_disk_size_gb" className="requiredasterisk">OS Disk Size (GB)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="azure_os_disk_size_gb"
                                                                       id="azure_os_disk_size_gb"
                                                                       component={renderField}
                                                                       validate={[number, minValue50]}
                                                                       placeholder="100"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_image_reference" className="requiredasterisk">OS Image Reference (JSON)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                       name="azure_image_reference"
                                                                       id="azure_image_reference"
                                                                       validate={required}
                                                                       component={renderTextArea}
                                                                       placeholder='{&#10;"publisher": "canonical",&#10;"offer": "0001-com-ubuntu-server-focal",&#10;"sku": "20_04-lts-gen2",&#10;"version": "latest"&#10;}'
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_network_sg" className="requiredasterisk">Network Security Group</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field name="azure_network_sg"
                                                                       id="azure_network_sg"
                                                                       component={renderField}
                                                                       validate={required}
                                                                       placeholder="/subscriptions/00000000-0000-0000-0000-000000000000/resourcegroups/development/providers/Microsoft.Network/networkSecurityGroups/example-nsg"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_subnet" className="requiredasterisk">Subnet</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field name="azure_subnet"
                                                                       id="azure_subnet"
                                                                       component={renderField}
                                                                       validate={required}
                                                                       placeholder="/subscriptions/00000000-0000-0000-0000-000000000000/resourceGroups/development/providers/Microsoft.Network/virtualNetworks/development-vnet/subnets/default"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_public_ip" className="requiredasterisk">Assign Public IP</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="checkbox"
                                                                       name="azure_public_ip"
                                                                       id="azure_public_ip"
                                                                       checked = {azure_public_ip_checked}
                                                                       component={renderCheckbox}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="5">
                                                                <Label htmlFor="azure_tags" >Tags (JSON)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                       name="azure_tags"
                                                                       id="azure_tags"
                                                                       component={renderTextArea}
                                                                       placeholder='{"name":"value"}'
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="5">
                                                                <Label htmlFor="azure_os_username" className="requiredasterisk">OS Username</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="text"
                                                                       name="azure_os_username"
                                                                       id="azure_os_username"
                                                                       component={renderField}
                                                                       validate={required}
                                                                       placeholder="testuser"
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_os_password" className="requiredasterisk">OS Password</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="password"
                                                                       name="azure_os_password"
                                                                       id="azure_os_password"
                                                                       component={renderPass}
                                                                       validate={required}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_ssh_public_key" className="requiredasterisk">SSH Public Key</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                       name="azure_ssh_public_key"
                                                                       id="azure_ssh_public_key"
                                                                       component={renderTextArea}
                                                                       validate={required}
                                                                       placeholder="ssh-rsa AAAAAAA...."
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_startup_script" className="requiredasterisk whitespacePre">Agent Startup Script</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                       name="azure_startup_script"
                                                                       id="azure_startup_script"
                                                                       component={renderTextArea}
                                                                       validate={required}
                                                                       placeholder="#!/bin/bash&#10;..."
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Row>
                                                            <Col sm="4">
                                                                <Label htmlFor="azure_config_override">Config Override (JSON)</Label>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <Field type="textarea"
                                                                       name="azure_config_override"
                                                                       id="azure_config_override"
                                                                       component={renderTextArea}
                                                                       placeholder='{"name" : "value"}'
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                </React.Fragment>
                                            }
                                        </React.Fragment>
                                    </TabPane>

                                </TabContent>
                            </React.Fragment>
                            }
                        </React.Fragment>
                    }
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm"
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit" size="sm"
                        className="submit-button"
                        color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

ZoneFormTemplate.propTypes = {
    updateZone: Proptypes.func.isRequired,
    getZones: Proptypes.func.isRequired,
    updatErrorWarning: Proptypes.func,
    history: Proptypes.object.isRequired,
    updateZoneError: Proptypes.func,
    createZoneError: Proptypes.func,
    fromUpdate: Proptypes.bool,
    createZone: Proptypes.func,
    errorCreateMessage: Proptypes.string,
    zones: Proptypes.array,
    getZoneLoading: Proptypes.bool,
    errorUpdateMessage: Proptypes.string,
    initialize: Proptypes.func,
    handleSubmit: Proptypes.func,
    licenses: Proptypes.array,
    zoneId: Proptypes.string
};


ZoneFormTemplate = reduxForm({ // eslint-disable-line
    form: "ZoneFormTemplate" // a unique identifier for this form
})(ZoneFormTemplate); // eslint-disable-line

const selector = formValueSelector('ZoneFormTemplate');

ZoneFormTemplate = connect(  // eslint-disable-line
    state => {
        const has_scaling_enabled = selector(state, 'auto_scaling_enabled');
        const has_aws_enabled = selector(state, 'aws_enabled');
        const has_do_enabled = selector(state, 'digital_ocean_enabled');
        const has_oci_enabled = selector(state, 'oci_enabled');
        const has_gcp_enabled = selector(state, 'gcp_enabled');
        const has_azure_enabled = selector(state, 'azure_enabled');
        const has_proxy = selector(state, 'proxy_connections');
        const has_dns = selector(state, 'register_dns');
        const has_dns_registration_provider = selector(state, 'dns_registration_provider');

        return {
            has_aws_enabled,
            has_do_enabled,
            has_oci_enabled,
            has_gcp_enabled,
            has_azure_enabled,
            has_scaling_enabled,
            has_proxy,
            has_dns,
            has_dns_registration_provider,
            zones: state.zones.zones || [],
            errorCreateMessage: state.zones.errorCreateMessage || null,
            errorUpdateMessage: state.zones.errorUpdateMessage || null,
            updateZoneError: state.zones.updateZoneError || null,
            getZoneLoading: state.zones.getZoneLoading || false,
            createZoneError: state.zones.createZoneError || null,
            initialValues: {enabled: true, auto_create_app_user: true, search_subtree: true},
            licenses: state.system_info.licenses
        }
    },
    dispatch => 
        ({
            updateZone: (data) => dispatch(updateZone(data)),
            getLicenses: () => dispatch(getLicenses()),
            getZones: () => dispatch(getZones())
        })) 
(ZoneFormTemplate);  //eslint-disable-line

export default withRouter(ZoneFormTemplate);